import { env } from '../../lib/env/env';

const GATEWAY_URL = env.getString('GATEWAY_URL') || 'http://localhost:9089';
export const analyticsApiConfig = {
  ANALYTICS_API_BASE_URL: `${GATEWAY_URL}/api/analytics`,
};
